module.exports = __webpack_public_path__ + "static/img/cdb1.266182ee.png";